import { Aggregator } from './aggregator';

/**
 * This class extends the Last class to calculate the last number of a metric.
 * The last number is the last value of the metric. The value is rounded to the precision given to the constructor or 4 by default.
 */
export class LastNumber extends Aggregator<number> {
  protected value: number | undefined = undefined;

  constructor(
    protected readonly initialValue?: number | undefined,
    private readonly precision = 4,
  ) {
    super();
  }

  protected _add(stat: number): void {
    this.value = stat;
  }

  override add(stat: number): void {
    super.add(stat);
  }

  override reset(): void {
    this.value = this.initialValue;
  }

  override getAggregated(): number | undefined {
    const multiplier = Math.pow(10, this.precision);

    if (this.value === undefined) {
      return this.initialValue;
    }

    return Math.round(this.value * multiplier) / multiplier;
  }
}
